import React, { useState } from "react";
import { Link } from "react-router-dom";
import Image from "../../lib/Image";
import { getKidCallback, userClickReport } from "../../utils/kidCallback";
import dayjs from "dayjs";

// 搜索推荐
export default ({
  kws,
  boardkw,
  gamekw,
  gameList,
  historySearch,
  setHistorySearch,
  setType,
  setGamekw,
  setIsShow,
  setSwiperIndex,
}) => {
  const [showDown, setShowDown] = useState(true);

  // 搜索历史、搜索推荐点击直接进行结果查询时 搜索词上报
  const searchBtnClick = async (word) => {
    console.log("分类搜索开始点击");

    // 同步生成三级kid
    let kid = await getKidCallback();
    // 点击搜索结果上报时的 父级kid
    sessionStorage.setItem("searchResultParentKid", kid);

    // 行为上报
    let reamrk = {
      search_time: dayjs().unix(),
      search_term: word,
    };
    userClickReport({
      target_action_type: "search",
      parent_id: sessionStorage.getItem("boxSecondKid"),
      kid,
      level: 3,
      action_code: "search_input",
      remark: JSON.stringify(reamrk),
    });
  };

  return (
    <div className={"search-cover " + (boardkw || gamekw ? "" : "active")}>
      <>
        {historySearch.length > 0 ? (
          <>
            <div
              className="title"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>搜索历史</span>
              <img
                style={{ height: "0.36rem" }}
                src="/resources/common/del.png"
                alt=""
                onClick={() => {
                  localStorage.removeItem("search-page-history");
                  setHistorySearch([]);
                }}
              />
            </div>
            <div
              className="kws"
              style={{
                height: showDown ? "28.5px" : "auto",
                overflow: "hidden",
                position: "relative",
                whiteSpace: "nowrap",
                paddingRight: showDown ? "26px" : "0", // 当只显示一行时 为下拉图标预留空间
              }}
            >
              {historySearch.map((kw, index) => (
                <div
                  key={index}
                  className="kw"
                  onClick={() => {
                    setType(2);
                    setGamekw(kw);
                    setIsShow(false);
                    setSwiperIndex(null);
                    searchBtnClick(kw);
                  }}
                  style={{ display: "inline-block", marginRight: "8px" }}
                >
                  {kw}
                </div>
              ))}

              {/* 图标固定在右侧 */}
              <img
                src={
                  showDown
                    ? "/resources/search/down.png"
                    : "/resources/search/up.png"
                }
                alt=""
                style={{
                  width: "26px",
                  height: "26px",
                  position: showDown ? "absolute" : "unset",
                  right: showDown ? 0 : "unset",
                  bottom: showDown ? "3px" : "8px",
                  cursor: "pointer",
                }}
                onClick={() => setShowDown(!showDown)}
              />
            </div>
          </>
        ) : null}
      </>

      <>
        {kws.length > 0 ? (
          <>
            <div className="title">大家都在搜</div>
            <div className="kws" style={{ marginTop: "16px" }}>
              {kws.map((kw, index) => (
                <div
                  key={index}
                  className="kws-item"
                  onClick={() => {
                    setType(2);
                    setGamekw(kw);
                    setIsShow(false);
                    setSwiperIndex(null);
                    searchBtnClick(kw);
                  }}
                >
                  {kw}
                </div>
              ))}
            </div>
          </>
        ) : null}
      </>

      <div className="groups clearfix">
        <div className="group">
          <div className="title">热搜游戏榜</div>
          <div className="games">
            {gameList.length > 0 &&
              gameList.map((game, index) => (
                <Link
                  key={game.game_id}
                  to={"/game?id=" + game.game_id}
                  className="game-list-global-type game-list-search-type"
                >
                  <div className="game-list-global-type-left">
                    <div
                      className="index"
                      style={{
                        color: index + 1 < 4 ? "#F34902" : "#7d7d7d",
                      }}
                    >
                      {index + 1}
                    </div>

                    <div className="icon">
                      <Image src={game?.game_image?.thumb} />
                    </div>
                    <div className="data">
                      <div className="name">
                        <div className="name-main" style={{ flex: "none" }}>
                          {game.game_name_main || game.game_name}
                        </div>

                        {index < 3 && (
                          <img
                            style={{ marginLeft: "6px", width: "16px" }}
                            src={`/resources/search/${index}.png`}
                          />
                        )}
                      </div>

                      <div className="desc">{game.game_classify_type}</div>
                    </div>
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
